import React from "react";
import SVG from "react-inlinesvg";
import {
    nearbyStoreSelector,
    preferredLocationSelector,
} from "tsi-common-react/src/apps/common/selectors";
import { useAppSelector } from "tsi-common-react/src/apps/reducers";
import { ILocation } from "tsi-common-react/src/models/location.interfaces";
import { msgid, ngettext, t } from "ttag";

import iconStoreLocatorFooter from "../../svg/store_locator_footer.svg";

const getAdText = (numStores: number, location: ILocation | null): string => {
    if (location) {
        return ngettext(
            msgid`${numStores} store near ${location.formatted_address}`,
            `${numStores} stores near ${location.formatted_address}`,
            numStores,
        );
    }
    return ngettext(
        msgid`${numStores} store near you`,
        `${numStores} stores near you`,
        numStores,
    );
};

export const NearbyStoresAd = (): React.ReactNode => {
    const numStores = useAppSelector(
        (state) => nearbyStoreSelector(state).length,
    );
    const location = useAppSelector(preferredLocationSelector);

    return (
        <div className="footer-widgets__offer">
            <SVG
                className="footer-widget__icon"
                src={iconStoreLocatorFooter}
                title={t`Locate a Store Icon`}
            />
            <div className="footer-widget__content">
                <h4>
                    <a
                        title={t`Find a Retailer`}
                        href="/find-a-retailer"
                        className="footer-widget__header"
                    >
                        {t`Feel it for yourself`}
                    </a>
                </h4>
                <span className="footer-widget__copy">
                    {getAdText(numStores, location)}
                </span>{" "}
                <a
                    title={t`Find a Retailer`}
                    href="/find-a-retailer"
                    className="text-link footer-widget__link"
                >
                    {t`See List`}
                </a>
            </div>
        </div>
    );
};
